import { render, staticRenderFns } from "./EditUserPasswordDialog.vue?vue&type=template&id=4659c701&scoped=true"
import script from "./EditUserPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./EditUserPasswordDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditUserPasswordDialog.vue?vue&type=style&index=0&id=4659c701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4659c701",
  null
  
)

export default component.exports